import { ROLES } from 'src/common/constants'

import "./style.css"
import { useContext, useMemo } from 'react'
import { getFromLocal, setToLocal } from 'src/utils'
import { useTranslation } from 'react-i18next'
import { forceLogout } from 'src/requests'
import { Logout } from 'src/requests/user'
import CommonBtn from '../ActionBtn/CommonBtn'
import { Context } from 'src/context'

const RolesInfo = {

    [ROLES.PHARMASIST]: {
        name: "Pharmasist's Dashboard",
        desc: "Manage patients, medications, and requests."

    },
    [ROLES.DOCTOR]: {
        name: "Doctor's Dashboard",
        desc: "Manage patients, medications, and requests."

    }

}


const Header = () => {

    const { i18n, t } = useTranslation()

    const { isLoggedIn, setSideBarCollapsed, sideBarCollapsed } = useContext(Context)

    const UserName: number | string = useMemo(() => getFromLocal("userName") || 0, [isLoggedIn])
    const RoleName: number | string = useMemo(() => getFromLocal("roleName") || 0, [isLoggedIn])

    const changeLang = () => {
        var nextLang = i18n.language == 'ar' ? 'en' : "ar"
        i18n.changeLanguage(nextLang)
        setToLocal("lang", nextLang)
    }

    const logOut = () => {
        Logout().finally(() => forceLogout())
    }

    return (
        <div className='separated-screen-header'>

            <div>
                <CommonBtn  name='' onApply={() => setSideBarCollapsed(!sideBarCollapsed)} icon={sideBarCollapsed ? "mdi:menu-open" : "mdi:menu"} />
            </div>

            <div className='user-btns'>
                <div className='user-info-data'>
                    <>
                        { //@ts-ignore
                            <div className='header-name'>{UserName}</div>}

                        { //@ts-ignore
                            <div className='header-desc'>{RoleName}</div>}
                    </>
                </div>
                {/* <CommonBtn name={i18n.language.toUpperCase()} onApply={changeLang} icon={"jam:language"} /> */}
                <CommonBtn name={`${t('log-out')}`} onApply={logOut} icon={"material-symbols:logout-rounded"} />
            </div>

        </div>
    )
}

export default Header